import { useEffect } from "react";

export function useLocalStorageSync() {
  useEffect(() => {
    const handleStorage = () => {
      window.dispatchEvent(new Event('storage-sync'));
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);
}
